import { redirectDocument } from 'react-router-dom';
import { genRouteMap } from '@/scripts/router';
import CallsIcon from '@/assets/images/menu/call.svg?react';
import CallsOnIcon from '@/assets/images/menu/callOn.svg?react';
import MessagesIcon from '@/assets/images/menu/message.svg?react';
import MessagesOnIcon from '@/assets/images/menu/messageOn.svg?react';
import FeedsIcon from '@/assets/images/menu/feeds.svg?react';
import FeedsOnIcon from '@/assets/images/menu/feedsOn.svg?react';
import ShortsIcon from '@/assets/images/menu/shorts.svg?react';
import ShortsOnIcon from '@/assets/images/menu/shortsOn.svg?react';
import MeIcon from '@/assets/images/menu/me.svg?react';
import WalletIcon from '@/assets/images/menu/wallet.svg?react';
import WalletOnIcon from '@/assets/images/menu/walletOn.svg?react';
import ContactsIcon from '@/assets/images/menu/contacts.svg?react';
import ContactsOnIcon from '@/assets/images/menu/contactsOn.svg?react';
import MeOnIcon from '@/assets/images/menu/meOn.svg?react';
import ChatContainer from '@/pages/messages/components/chat/chatContainer';
import ChatSider from '@/pages/messages/components/chat/chatSider';
import UnreadContainer from '@/pages/messages/components/unread/unreadContainer';
import UnreadSider from '@/pages/messages/components/unread/unreadSider';
import Notifications from '@/pages/settings/components/notifications';
import Security from '@/pages/settings/components/security';
import Privacy from '@/pages/settings/components/privacy';
import About from '@/pages/settings/components/about';
import { userApis } from '../apis/user';
import Paths from './paths';
import { ActionKeys } from './actions';

export const routeMap = genRouteMap({
  [Paths.BASE]: {
    loader: async ({ request }) => {
      const url = new URL(request.url);
      // TODO
      if (userApis.getToken()) {
        if (
          ['/', Paths.MAIN, Paths.MAIN + '/', Paths.MESSAGES_PATH].includes(
            url.pathname
          )
        ) {
          return redirectDocument(Paths.MESSAGES_CHATS);
        } else if (url.pathname === Paths.SETTINGS) {
          return redirectDocument(Paths.SETTINGS_NOTIFICATIONS);
        }
        return null;
      }
      return url.pathname === Paths.LOGIN ? null : redirectDocument(Paths.LOGIN);
    },
  },
  [Paths.LOGIN]: {
    auth: {
      key: Paths.LOGIN,
      actions: [ActionKeys.VIEW],
    },
  },
  [Paths.AUTH_CALLBACK]: {
    auth: {
      key: Paths.AUTH_CALLBACK,
      actions: [ActionKeys.VIEW],
    },
  },
  [Paths.MAIN]: {
    auth: {
      key: Paths.MAIN,
      actions: [ActionKeys.VIEW],
    },
  },

  [Paths.CALLS]: {
    auth: {
      key: Paths.CALLS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: 'Calls',
      icon: <CallsIcon />,
      activeIcon: <CallsOnIcon />,
    },
  },

  [Paths.MESSAGES_PATH]: {
    menu: {
      label: 'Message',
      icon: <MessagesIcon />,
      activeIcon: <MessagesOnIcon />,
    },
  },
  [Paths.MESSAGES]: {
    auth: {
      key: Paths.MESSAGES,
      actions: [ActionKeys.VIEW],
    },
  },
  [Paths.MESSAGES_CHATS]: {
    auth: {
      key: Paths.MESSAGES_CHATS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: 'Chats',
      icon: <ShortsIcon />,
      element: <ChatContainer></ChatContainer>,
      siderElement: <ChatSider></ChatSider>,
    },
  },
  [Paths.MESSAGES_UNREAD]: {
    auth: {
      key: Paths.MESSAGES_UNREAD,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: 'Unread',
      icon: <ShortsIcon />,
      element: <UnreadContainer></UnreadContainer>,
      siderElement: <UnreadSider></UnreadSider>,
    },
  },

  [Paths.FEEDS]: {
    auth: {
      key: Paths.FEEDS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: 'Feeds',
      icon: <FeedsIcon />,
      activeIcon: <FeedsOnIcon />,
    },
  },

  [Paths.SHORTS]: {
    auth: {
      key: Paths.SHORTS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: 'Shorts',
      icon: <ShortsIcon />,
      activeIcon: <ShortsOnIcon />,
    },
  },

  [Paths.User]: {
    auth: {
      key: Paths.User,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: 'Me',
      icon: <MeIcon />,
      activeIcon: <MeOnIcon />,
    },
  },
  [Paths.Wallet]: {
    auth: {
      key: Paths.Wallet,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: 'Wallet',
      icon: <WalletIcon />,
      activeIcon: <WalletOnIcon />,
    },
  },
  [Paths.CONTACTS]: {
    auth: {
      key: Paths.CONTACTS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      label: 'Contacts',
      icon: <ContactsIcon />,
      activeIcon: <ContactsOnIcon />,
    },
  },
  [Paths.SETTINGS_PATH]: {},
  [Paths.SETTINGS]: {
    auth: {
      key: Paths.SETTINGS,
      actions: [ActionKeys.VIEW],
    },
  },
  [Paths.SETTINGS_NOTIFICATIONS]: {
    auth: {
      key: Paths.SETTINGS_NOTIFICATIONS,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      element: <Notifications></Notifications>,
    },
  },
  [Paths.SETTINGS_SECURITY]: {
    auth: {
      key: Paths.SETTINGS_SECURITY,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      element: <Security></Security>,
    },
  },
  [Paths.SETTINGS_PRIVACY]: {
    auth: {
      key: Paths.SETTINGS_PRIVACY,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      element: <Privacy></Privacy>,
    },
  },
  [Paths.SETTINGS_ABOUT]: {
    auth: {
      key: Paths.SETTINGS_ABOUT,
      actions: [ActionKeys.VIEW],
    },
    menu: {
      element: <About></About>,
    },
  },
});
